import React from 'react';

const CloudConsulting: React.FC = () => {
  return (
    <div className="page cloud-consulting">
      <div className="container">
        <div className="hero-section">
          <h1>Cloud Consulting Services</h1>
          <p className="hero-description">
            Strategic guidance for cloud adoption, migration, and optimization. 
            Expertise in AWS, Azure, and multi-cloud architectures.
          </p>
        </div>

        <section className="coming-soon-section">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">
              <i className="fa-solid fa-cloud"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>
              Detailed cloud consulting services are currently under development. This page will include 
              comprehensive information about cloud strategy, migration planning, architecture design, 
              and optimization services.
            </p>
            <a href="/contact" className="contact-btn">Contact for Early Access</a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CloudConsulting;